// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"85":"4683fdc2","193":"1799aba4","865":"48b091a4"}[chunkId] + ".css";
};